import { SoundByte, SoundType } from "../enum/sounds";
import MonoBehavior from "../lib/MonoBehavior";
import { Time } from "../lib/Time";
import { Physics } from "../math/Physics";
import Vector2 from "../math/Vector2";
import Color from "../util/Color";
import Explosion from "./Explosion";
import SoundManager from "./SoundManager";
import SPBogey from "./SPBogey";
import SPGameManager from "./SPGameManager";
import SPPlayer from "./SPPlayer";
import Trail from "./Trail";

export default class SPBullet extends MonoBehavior {

    velocity: Vector2 = Vector2.zero;
    damage = 1;
    isPlayerBullet = true;
    maxEnemiesHit = 1;
    owner: SPBogey|SPPlayer|undefined;
    size = 2;
    isOrb = false;
    arcBlaster = false;

    get timeAlive() {return Time.time - this.born;}

    private enemiesHit: string[] = [];
    private arcEnemiesHit: string[] = [];
    private arcTarget: SPBogey|undefined;

    Die(color?: Color) {
        this.engine.NewGameObjectWithScript(Explosion, {
            position: this.transform.position,
            initialValues: {
                size: this.size,
                w: this.size * 2,
                color: color || new  Color(255,255,255)
            }
        });

        this.engine.RemoveGameObject(this.gameObject);
    }

    BeginArc() {
        const trail: Trail = this.gameObject.AddScript(Trail);
        try {
            trail.color = new Color(85,255,85);
        } catch (error) {
            
        }

        let closest = Number.MAX_SAFE_INTEGER, closestTarget: SPBogey|undefined, closestVec: Vector2|undefined;

        for (const bogey of this.engine.GetGameObjectsBehaviors<SPBogey>(SPBogey).filter(
            v => !this.arcEnemiesHit.includes(v.gameObject.id)
        )) {
            const vec = bogey.transform.position.sub(this.transform.position);
            const dist = vec.magnitude;
            vec.normalize();

            if (dist < closest) {
                closest = dist;
                closestTarget = bogey;
                closestVec = vec;
            }
        }

        if (!closestTarget || !closestVec || closest > 128) {
            this.Die();
            return;
        }

        this.arcTarget = closestTarget;
    }

    Hit(target: SPBogey|SPPlayer) {
        const explCol = new Color(255,255,255);

        if (target instanceof SPBogey) {
            const critChance = Math.max(0, SPPlayer.Singleton.critChance);
            this.enemiesHit.push(target.gameObject.id);
            const isCrit = Math.random() < critChance;
            target.Damage(isCrit ? this.damage * 2 : this.damage, {attacker: this.owner});

            if (isCrit) explCol.b = 80;
            if (this.arcBlaster) {
                this.arcEnemiesHit.push(target.gameObject.id);
                this.BeginArc();
            }
        } else {
            target.Damage(this.damage, {attacker: this.owner});
        }

        SoundManager.Singleton.PlaySound(SoundByte.BulletHit, SoundType.SFX);

        if (!this.arcBlaster && (this.enemiesHit.length >= this.maxEnemiesHit || target instanceof SPPlayer)) this.Die(explCol);
        else if (this.arcBlaster && this.arcEnemiesHit.length >= 6) {
            this.Die(explCol);
        }
        else {
            this.engine.NewGameObjectWithScript(Explosion, {
                position: this.transform.position,
                initialValues: {
                    size: this.size,
                    w: this.size*2,
                    color: explCol
                }
            });
        }
    }

    Update(): void {
        if (!SPGameManager.Singleton.isInGameOrGameOver) return;

        if (this.isPlayerBullet) {
            for (const bogey of this.engine.GetGameObjectsBehaviors<SPBogey>(SPBogey).filter(
                v => !this.enemiesHit.includes(v.gameObject.id)
            )) {
                //@ts-ignore
                if (this.enemiesHit.includes(bogey.gameObject.id) || bogey.isFriendly) continue;

                if (Physics.CircleCircleCollision({
                    position: this.transform.position,
                    radius: this.size
                }, {
                    position: bogey.transform.position,
                    radius: bogey.size
                }) !== false) {
                    this.Hit(bogey);
                    return;
                }
    
            }
        } else {
            const player = this.engine.GetGameObjectsBehaviors<SPPlayer>(SPPlayer)[0];

            if (player) {
                if (Physics.CircleCircleCollision({
                    position: this.transform.position,
                    radius: this.size
                }, {
                    position: player.transform.position,
                    radius: player.size
                }) !== false) {
                    this.Hit(player);
                }
            }
            
        }
        

        if (this.timeAlive >= 5) {
            this.Die();
            return;
        }

        if (this.arcTarget) {
            this.velocity = this.arcTarget.transform.position.sub(this.transform.position).normalized.scale(this.velocity.magnitude);
        }

        this.transform.position = this.transform.position.add(this.velocity.scale(Time.deltaTime));
    }

    LateUpdate(): void {
        this.transform.rotation = this.velocity.normalized;
    }

    Draw(): void {

        this.ctx.lineWidth = 2;
        this.ctx.strokeStyle = this.isPlayerBullet ? '#80ff80' : '#ff8080';

        if (this.isOrb) {
            this.engine.StrokeCircle(this.transform.position, this.size);
            return;
        }

        this.engine.Line(
            this.transform.position.add(this.transform.forward.scale(this.size)),
            this.transform.position.add(this.transform.back.scale(this.size))
        );
    }

    DrawGizmos(): void {
        if (this.arcBlaster) {
            this.ctx.fillStyle = '#ffffff30';
            this.engine.FillCircle(this.transform.position, 128)
        }
    }

}